<template>
  <div id="mainDiv">
    <b-card title="Welcome to the Sublime" id="loginCard">
      <!-- LOGIN FORM -->
      <b-form @submit.prevent="login">
        <b-input
          type="email"
          class="login_input"
          id="email_input"
          placeholder="Email"
        />
        <b-input
          type="password"
          class="login_input"
          id="password_input"
          placeholder="Password"
        />

        <b-button type="submit" id="login_btn" variant="primary">
          <strong>Login</strong>
        </b-button>
      </b-form>
    </b-card>
  </div>
</template>



<script>
import firebase from "firebase";

export default {
  name: "Sublime",
  methods: {
    login: function () {
      // get document elements
      let emailInput = document.getElementById("email_input");
      let passwordInput = document.getElementById("password_input");

      // get values from elements (input)
      let email = emailInput.value;
      let password = passwordInput.value;

      // login with firebase (email & password)
      let _this = this;
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(function (user) {
          // user signed in
          _this.$router.push("/");
        })
        .catch(function (error) {
          // Handle errors here
          let errorCode = error.code;
          let errorMessage = error.message;
          alert(errorMessage + "\nError Code: " + errorCode);
        });
    },
  },
  mounted() {},
};
</script>

<style scoped>
#loginCard {
  max-width: 40rem;
  margin-top: 7vh;
  margin-right: auto;
  margin-left: auto;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  align-content: center;
}

#login_btn {
  margin-top: 1.5vh;
  margin-left: auto;
  font-size: 1.1rem;
}

.login_input {
  margin-top: 1vh;
}
</style>


// WEBPACK FOOTER //
// src/components/Sublime.vue